import { render, staticRenderFns } from "./phenologiesDatabase.vue?vue&type=template&id=0142c542&"
import script from "./phenologiesDatabase.vue?vue&type=script&lang=js&"
export * from "./phenologiesDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports